import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, ShieldCheckIcon, ClockIcon, SmileIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function About() {
  const values = [{
    icon: CheckCircleIcon,
    title: 'Reliable',
    desc: 'We arrive on time and complete repairs to the highest standard'
  }, {
    icon: ShieldCheckIcon,
    title: 'Transparent',
    desc: 'Clear pricing with no hidden fees or surprises'
  }, {
    icon: SmileIcon,
    title: 'Polite',
    desc: 'Courteous, respectful service in your home'
  }, {
    icon: ClockIcon,
    title: 'Professional',
    desc: 'Qualified engineers working to manufacturer standards'
  }];
  return <div className="w-full bg-white py-16" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h1 className="text-4xl font-bold text-slate-800 mb-4" data-id="element-150">
            About Brighthands
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-151">
            Your trusted UK team for professional appliance repairs
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-152">
          <div className="relative h-96 rounded-lg overflow-hidden shadow-xl" data-id="element-153">
            <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=600&fit=crop" alt="Professional engineer with tools in customer's kitchen – appliance repair service" className="w-full h-full object-cover" data-id="element-154" />
          </div>
          <div data-id="element-155">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-156">
              Who We Are
            </h2>
            <p className="text-slate-600 mb-4" data-id="element-157">
              We're a UK team specialising in domestic appliance repairs —
              washing machines, dishwashers, tumble dryers, cookers, fridges and
              TVs.
            </p>
            <p className="text-slate-600 mb-4" data-id="element-158">
              Based in Portsmouth, our qualified engineers serve customers
              across England, Scotland, and Wales. We listen to your concerns,
              arrive on time, and work safely to manufacturer standards.
            </p>
            <p className="text-slate-600" data-id="element-159">
              Whether you need an emergency callout or scheduled maintenance,
              we're here to help with professional diagnostics and efficient
              repairs.
            </p>
          </div>
        </div>
        <div className="bg-slate-50 rounded-xl p-8 mb-16" data-id="element-160">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center" data-id="element-161">
            Our Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-162">
            {values.map((value, index) => <div key={index} className="text-center" data-id="element-163">
                <value.icon className="w-12 h-12 text-teal-600 mx-auto mb-4" data-id="element-164" />
                <h3 className="text-xl font-semibold text-slate-800 mb-3" data-id="element-165">
                  {value.title}
                </h3>
                <p className="text-slate-600" data-id="element-166">{value.desc}</p>
              </div>)}
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-167">
          <div data-id="element-168">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-169">
              Why Choose Brighthands?
            </h2>
            <ul className="space-y-4" data-id="element-170">
              {['UK-based qualified and insured engineers', 'Experience with all major appliance brands', 'Same-day and emergency callouts available', 'Professional diagnostics and maintenance', 'Competitive and transparent pricing', 'Work completed to manufacturer standards'].map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-171">
                  <CheckCircleIcon className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-172" />
                  <span className="text-slate-700" data-id="element-173">{point}</span>
                </li>)}
            </ul>
          </div>
          <div className="relative h-96 rounded-lg overflow-hidden shadow-xl" data-id="element-174">
            <img src="https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=800&h=600&fit=crop" alt="Engineer repairing appliance in customer's kitchen – professional diagnostics" className="w-full h-full object-cover" data-id="element-175" />
          </div>
        </div>
        <div className="bg-teal-50 rounded-xl p-8 border border-teal-100" data-id="element-176">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center" data-id="element-177">
            Get in Touch
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-178">
            <div data-id="element-179">
              <h3 className="text-xl font-semibold text-slate-800 mb-6" data-id="element-180">
                Contact Information
              </h3>
              <div className="space-y-4 mb-8" data-id="element-181">
                <div className="flex items-start gap-3" data-id="element-182">
                  <MapPinIcon className="w-5 h-5 text-teal-600 flex-shrink-0 mt-1" data-id="element-183" />
                  <div data-id="element-184">
                    <p className="font-medium text-slate-800" data-id="element-185">Address</p>
                    <p className="text-slate-600" data-id="element-186">
                      5 London Rd, Portsmouth PO2 0BQ
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-187">
                  <PhoneIcon className="w-5 h-5 text-teal-600 flex-shrink-0 mt-1" data-id="element-188" />
                  <div data-id="element-189">
                    <p className="font-medium text-slate-800" data-id="element-190">Phone</p>
                    <a href="tel:08000554969" className="text-teal-600 hover:text-teal-700" data-id="element-191">
                      0800 055 4969
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-192">
                  <MailIcon className="w-5 h-5 text-teal-600 flex-shrink-0 mt-1" data-id="element-193" />
                  <div data-id="element-194">
                    <p className="font-medium text-slate-800" data-id="element-195">Email</p>
                    <a href="mailto:Sumittandon092@gmail.com" className="text-teal-600 hover:text-teal-700 break-all" data-id="element-196">
                      Sumittandon092@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <Link to="/contact" className="inline-block bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition" data-id="element-197">
                Visit Contact Page
              </Link>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-198">
              <h3 className="text-xl font-semibold text-slate-800 mb-4" data-id="element-199">
                Quick Contact Form
              </h3>
              <form className="space-y-4" data-id="element-200">
                <div data-id="element-201">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-202">
                    Name
                  </label>
                  <input type="text" className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your name" data-id="element-203" />
                </div>
                <div data-id="element-204">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-205">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="your.email@example.com" data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-208">
                    Phone
                  </label>
                  <input type="tel" className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Your phone number" data-id="element-209" />
                </div>
                <div data-id="element-210">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-211">
                    Postcode
                  </label>
                  <input type="text" className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="e.g. PO2 0BQ" data-id="element-212" />
                </div>
                <div data-id="element-213">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-214">
                    Appliance
                  </label>
                  <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" data-id="element-215">
                    <option data-id="element-216">Select appliance</option>
                    <option data-id="element-217">Washing Machine</option>
                    <option data-id="element-218">Dishwasher</option>
                    <option data-id="element-219">Tumble Dryer</option>
                    <option data-id="element-220">Cooker/Oven</option>
                    <option data-id="element-221">Fridge/Freezer</option>
                    <option data-id="element-222">TV</option>
                  </select>
                </div>
                <div data-id="element-223">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-224">
                    Fault Notes
                  </label>
                  <textarea rows={3} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="Describe the issue with your appliance" data-id="element-225" />
                </div>
                <button type="submit" className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition" data-id="element-226">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>;
}